import React, { useEffect, useState } from "react";
import { Marker, InfoWindow } from "@react-google-maps/api";
import { AQIDataItem } from "../utils/types";
import AQIProgressModal from "./AqiProgressGraph";

interface MarkerViewProps {
  data: AQIDataItem;
  index: number;
  noAnimation?: boolean;
}

export const MarkerView: React.FC<MarkerViewProps> = ({
  data,
  index,
  noAnimation,
}) => {
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowInfo(false), 10000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Marker
      position={{ lat: data.lat, lng: data.long }}
      onClick={() => setShowInfo(true)}
      label={data.aqi.toString()}
      icon={{
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: data.color,
        fillOpacity: 1,
        strokeColor: data.stncode.includes("DXAQMS") ? "#FFC0CB" : "#8F00FF",
        strokeWeight: 4,
        scale: 15,
      }}
    >
      {showInfo && (
        <InfoWindow
          onCloseClick={() => setShowInfo(false)}
          options={{ headerDisabled: true }}
        >
          <div className=" bg-white">
            <button
              onClick={() => setShowInfo(false)}
              className="text-gray-500 hover:text-gray-700 focus:outline-none text-base absolute top-0 right-1"
              aria-label="Close Info Window"
            >
              ✖
            </button>
            <div className="flex items-center justify-between gap-2">
              <p className="font-semibold text-base ml-4 ">{data.stnname}</p>
            </div>
            <AQIProgressModal data={data} />
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
};
